"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isFileValid(file, _ref) {
  var allowedExtensions = _ref.allowedExtensions,
    sizeLimit = _ref.sizeLimit;
  var isValidUrl = file.url !== '';
  var invalidUrlMessage = isValidUrl ? '' : "URL ".concat(file === null || file === void 0 ? void 0 : file.url, " n\xE3o \xE9 v\xE1lido");
  var isValidExtension = allowedExtensions === undefined || (allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.find(function (extension) {
    return extension === file.extension;
  })) !== undefined;
  var invalidExtensionMessage = isValidExtension ? '' : "Extens\xE3o ".concat(file === null || file === void 0 ? void 0 : file.extension, " n\xE3o \xE9 v\xE1lida");
  var isValidSize = sizeLimit === undefined || (file === null || file === void 0 ? void 0 : file.size) <= sizeLimit;
  var invalidSizeMessage = isValidSize ? '' : "Tamanho ".concat(file === null || file === void 0 ? void 0 : file.size, " excede o limite permitido'");
  var isValid = isValidUrl && isValidExtension && isValidSize;
  var message = [invalidUrlMessage, invalidExtensionMessage, invalidSizeMessage].filter(function (message) {
    return message.length > 0;
  }).join(', ');
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isFileValid);